<script type="text/jsx">
import env from 'config/env';
import Icon from '@/common/UIToolKit/Icon.vue';
import UiHelplineButton from '@/ui/v1/controls/UiHelplineButton.vue';

export default {
    functional: true,
    render(h, { parent }) {
        const homepageUrl = env.JOBILLA_URL;

        return <div class="w-full h-screen flex flex-col items-center justify-center">
            <Icon for="jobibot-sad" class="w-36 h-36" />
            <h1 class="text-size-0 mt-md">{ parent.$t('common.error_pages.public_404.title') }</h1>
            <i18n path="common.error_pages.public_404.description" tag="p" class="text-2 mt-md max-w-md text-center">
                <a place="homepage_link" class="text-purple font-semibold" href={homepageUrl}>{ parent.$t('common.error_pages.public_404.homepage_link') }</a>
                <UiHelplineButton type="text" class="text-size-2 font-semibold" place="contact">{ parent.$t('common.error_pages.public_404.contact') }</UiHelplineButton>
            </i18n>
            <a href={homepageUrl} class="mt-md ui-btn ui-secondary-btn">{ parent.$t('common.error_pages.404.button_text') }</a>
        </div>;
    },
};
</script>
